/*
 *
 * WebhookNotifications actions
 *
 */

import {
  DEFAULT_ACTION,
  ENABLE_LOADER,
  DISABLE_LOADER,
  GET_WEBHOOK_NOTIFICATIONS,
  UPDATE_WEBHOOK_NOTIFICATIONS_STATUS,
  HANDLE_UPDATE_WEBHOOK_NOTIFICATIONS_STATUS,
  UPDATE_WEBHOOK_NOTIFICATIONS_DATA,
  GET_NOTIFICATION_CHANNEL_DETAILS,
  ADD_NOTIFICATION_CHANNEL_DETAILS,
  UPDATE_NOTIFICATION_CHANNEL_DETAILS,
  HANDLE_UPDATE_NOTIFICATION_CHANNEL_DETAILS,
  HANDLE_ADD_NOTIFICATION_CHANNEL_DETAILS_RESPONSE,
  RESET_DATA,
  GET_MERCHANT_CONFIG,
  UPDATE_MERCHANT_CONFIG,
  TEST_WEBHOOK,
  GET_MERCHANT_KEY,
  GET_SUBSCRIPTIONS_WEBHOOK,
  UPDATE_SUBSCRIPTIONS_WEBHOOK,
  GET_CONFIGURED_WEBHOOKS,
  GET_ALL_NOTIFICATION_TYPES,
  CREATE_BULK_NOTIFICATION_CHANNEL,
  GET_ALL_NOTIFICATION_VERSIONS,
  UPDATE_WEBHOOK_VERSIONS,
  SAVE_ABANDONED_CHECKOUT_WEBHOOK,
  GET_ABANDONED_CHECKOUT_SECRET_KEY,
  UPDATE_ABANDONED_CHECKOUT_SECRET_KEY,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function updateWebhookNotificationsDataAction(data) {
  return {
    type: UPDATE_WEBHOOK_NOTIFICATIONS_DATA,
    data,
  };
}

export function getAbandonedCheckoutSecretKeyAction(data) {
  return {
    type: GET_ABANDONED_CHECKOUT_SECRET_KEY,
    data,
  };
}

export function updateAbandonedCheckoutSecretKeyAction(data) {
  return {
    type: UPDATE_ABANDONED_CHECKOUT_SECRET_KEY,
    data,
  };
}

export function saveAbandondedCheckoutWebhookAction(data) {
  return {
    type: SAVE_ABANDONED_CHECKOUT_WEBHOOK,
    data,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function getWebhookNotificationsAction(data) {
  return {
    type: GET_WEBHOOK_NOTIFICATIONS,
    data,
  };
}

export function updateWebhookNotificationsStatusAction(data) {
  return {
    type: UPDATE_WEBHOOK_NOTIFICATIONS_STATUS,
    data,
  };
}

export function handleUpdateWebhookNotificationsResponse(data) {
  return {
    type: HANDLE_UPDATE_WEBHOOK_NOTIFICATIONS_STATUS,
    data,
  };
}

export function resetDataAction() {
  return {
    type: RESET_DATA,
  };
}

export function getNotificationChannelDetailsAction(data) {
  return { type: GET_NOTIFICATION_CHANNEL_DETAILS, data };
}

export function addNotificationChannelDetailsAction(data) {
  return {
    type: ADD_NOTIFICATION_CHANNEL_DETAILS,
    data,
  };
}

export function updateNotificationChannelDetailsAction(data) {
  return {
    type: UPDATE_NOTIFICATION_CHANNEL_DETAILS,
    data,
  };
}

export function getMerchantConfigAction(data) {
  return { type: GET_MERCHANT_CONFIG, data };
}

export function updateMerchantConfigAction(data) {
  return {
    type: UPDATE_MERCHANT_CONFIG,
    data,
  };
}

export function handleUpdateNotificationChannelResponse(data) {
  return {
    type: HANDLE_UPDATE_NOTIFICATION_CHANNEL_DETAILS,
    data,
  };
}

export function addNotificationChannelDetailsResponse(data) {
  return {
    type: HANDLE_ADD_NOTIFICATION_CHANNEL_DETAILS_RESPONSE,
    data,
  };
}

export function testWebhookAction(data) {
  return {
    type: TEST_WEBHOOK,
    data,
  };
}

export function getMerchantKeyAction(data) {
  return {
    type: GET_MERCHANT_KEY,
    data,
  };
}

export function getSubscriptionsWebhookAction(data) {
  return {
    type: GET_SUBSCRIPTIONS_WEBHOOK,
    data,
  };
}

export function updateSubscriptionsWebhookAction(data) {
  return {
    type: UPDATE_SUBSCRIPTIONS_WEBHOOK,
    data,
  };
}

export function getConfiguredWebhooksAction(data) {
  return {
    type: GET_CONFIGURED_WEBHOOKS,
    data,
  };
}

export function getAllNotificationTypesAction(data) {
  return {
    type: GET_ALL_NOTIFICATION_TYPES,
    data,
  };
}

export function createBulkNotificationChannelAction(data) {
  return {
    type: CREATE_BULK_NOTIFICATION_CHANNEL,
    data,
  };
}

export function getAllNotificationVersionsAction(data) {
  return {
    type: GET_ALL_NOTIFICATION_VERSIONS,
    data,
  };
}

export function updateWebhookVersionsAction(data) {
  return {
    type: UPDATE_WEBHOOK_VERSIONS,
    data,
  };
}
